import React from 'react';
import { jsx } from '@emotion/core';
import moment from 'moment';
import { IGender } from '../../../utils/types';
import DataTable from '../../../components/table/DataTable';
/**@jsx jsx*/

type Actions = { label: string; action: (gender: IGender) => void }[];

interface IProps {
  genders?: IGender[];
  actions: Actions;
  isLoading?: boolean;
}

const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt: Date) => {
      return <span>{moment(createdAt).format('DD/MM/YYYY')}</span>;
    },
  },
  {
    title: 'Last Changed',
    dataIndex: 'lastChanged',
    key: 'lastChanged',
    render: (lastChanged: Date) => {
      return <span>{moment(lastChanged).format('DD/MM/YYYY')}</span>;
    },
  },
];

const GendersTable: React.FC<IProps> = ({
  genders = [],
  actions,
  isLoading,
}) => {
  return (
    <DataTable
      showControls
      showPagination
      data={genders}
      columns={columns}
      actions={actions}
      searchFilter="name"
      isLoading={isLoading}></DataTable>
  );
};

export default GendersTable;
